module.exports = __webpack_public_path__ + "static/media/mercuryzone--main.45dc8553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/mercuryzone/mercuryzone--main.jpg
// module id = 161
// module chunks = 0